import script from "./OtonanTelubulanan.vue?vue&type=script&setup=true&lang=js"
export * from "./OtonanTelubulanan.vue?vue&type=script&setup=true&lang=js"

import "./OtonanTelubulanan.vue?vue&type=style&index=0&id=b6efdc24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6efdc24"]])

export default __exports__